(function($) {

	'use strict';

	var init = function() {
		
		disabledRef();

	};

	var disabledRef = function() {

		$( ".job-reference > div > input" ).attr( "readonly", "readonly" );
	}

	$(document).ready(function() {
		if($('div').hasClass('gform_body')) {
			init();
		}
	});

})(jQuery);